'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { Button } from '@/components/ui/button';
import LogoBlackIcon from '@/icons/LogoBlackIcon';
import { LANDING_LINKS } from './constants';

const DesktopNav = ({ activeId }: { activeId: string | null }) => {
  const pathname = usePathname();

  return (
    <div className='flex w-full items-center space-x-8'>
      <Link
        href='/'
        className='flex'
        aria-label='Booli, till startsidan.'
      >
        <LogoBlackIcon />
      </Link>
      <div className='flex w-full justify-center space-x-7'>
        <div className='flex space-x-6'>
          {LANDING_LINKS.map(({ id, label }) => (
            <Link
              key={id}
              href={`/#${id}`}
              data-active={activeId === id}
              className='cursor-pointer transition-all duration-300 hover:opacity-75 data-[active=true]:text-bui-color-orange'
            >
              {label}
            </Link>
          ))}
        </div>
      </div>
      <div className='flex items-center gap-x-6'>
        <Link
          href='/indices'
          data-active={pathname.includes('indices')}
          className='cursor-pointer transition-all duration-300 hover:opacity-75 data-[active=true]:text-bui-color-orange'
        >
          Prisindex
        </Link>
        <a
          href='/auth/login'
          className='whitespace-nowrap'
        >
          <Button variant={'outline'}>Logga in</Button>
        </a>
      </div>
    </div>
  );
};

export default DesktopNav;
